"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETHAddress = exports.N3Address = exports.NEOAddress = exports.SWTHAddress = exports.wifEncodePrivateKey = exports.randomMnemonic = exports.BIP44Path = exports.stringOrBufferToBuffer = void 0;
const constant_1 = require("../constant");
const neon_core_next_1 = require("@cityofzion/neon-core-next");
const Base58Check = __importStar(require("base58check"));
const bech32 = __importStar(require("bech32"));
const BIP32 = __importStar(require("bip32"));
const BIP39 = __importStar(require("bip39"));
const crypto_js_1 = __importDefault(require("crypto-js"));
const ethers_1 = require("ethers");
const secp256k1 = __importStar(require("secp256k1"));
const secp256r1 = __importStar(require("secp256r1"));
const wif = __importStar(require("wif"));
const generic_1 = require("./generic");
const BIP44_PURPOSE = 44;
const NEO_COIN_TYPE = 0x00000378;
const ETH_COIN_TYPE = 0x0000003c;
const SWTH_COIN_TYPE = 118;
/**
 * Convenience function to coalesce a string/buffer into a buffer
 *
 * @param stringOrBuffer a string or buffer type
 * @param encoding BufferEncoding from Buffer
 * @param force option to return an empty buffer regardless of input
 */
const stringOrBufferToBuffer = (stringOrBuffer, encoding = "hex", force = false) => {
    if (typeof stringOrBuffer === "string") {
        return Buffer.from(stringOrBuffer, encoding);
    }
    if (stringOrBuffer instanceof Buffer) {
        return stringOrBuffer;
    }
    // not a string nor buffer
    // e.g. null/undefined
    if (force) {
        return Buffer.alloc(0);
    }
    // if not forcing to return an empty buffer, return null
    return null;
};
exports.stringOrBufferToBuffer = stringOrBufferToBuffer;
class BIP44Path {
    constructor(purpose = BIP44_PURPOSE, coinType = SWTH_COIN_TYPE, account = 0, change = 0, index = 0) {
        this.purpose = purpose;
        this.coinType = coinType;
        this.account = account;
        this.change = change;
        this.index = index;
    }
    static generateBIP44String(index = 0, change = 0, account = 0, coinType = 0, purpose = 0) {
        return `m/${purpose}'/${coinType}'/${account}'/${change}/${index}`;
    }
    update(index = this.index, change = this.change, account = this.account, coinType = this.coinType, purpose = this.purpose) {
        this.index = index;
        this.change = change;
        this.account = account;
        this.coinType = coinType;
        this.purpose = purpose;
        return this;
    }
    toArray() {
        return [this.purpose, this.coinType, this.account, this.change, this.index];
    }
    generate() {
        return BIP44Path.generateBIP44String(this.index, this.change, this.account, this.coinType, this.purpose);
    }
}
exports.BIP44Path = BIP44Path;
const randomMnemonic = () => {
    return BIP39.generateMnemonic();
};
exports.randomMnemonic = randomMnemonic;
const wifEncodePrivateKey = (privateKey, iter = 128) => {
    const privateKeyBuf = exports.stringOrBufferToBuffer(privateKey);
    return wif.encode(iter, privateKeyBuf, true);
};
exports.wifEncodePrivateKey = wifEncodePrivateKey;
exports.SWTHAddress = {
    newMnemonic: () => {
        return exports.randomMnemonic();
    },
    coinType: () => {
        return SWTH_COIN_TYPE;
    },
    keyDerivationPath: (index = 0, change = 0, account = 0) => {
        const coinType = exports.SWTHAddress.coinType();
        return new BIP44Path(BIP44_PURPOSE, coinType).update(index, change, account).toArray();
    },
    publicKeyToScriptHash: (publicKey) => {
        const pubKeyBuffer = exports.stringOrBufferToBuffer(publicKey);
        const sha256Hash = ethers_1.ethers.utils.sha256(pubKeyBuffer);
        const ripemdHash = ethers_1.ethers.utils.ripemd160(sha256Hash);
        return generic_1.stripHexPrefix(ripemdHash);
    },
    publicKeyToAddress: (publicKey, opts) => {
        const scriptHash = exports.SWTHAddress.publicKeyToScriptHash(publicKey);
        const address = exports.SWTHAddress.encode(scriptHash, opts);
        return address;
    },
    encodePublicKey: () => {
        throw new Error("SWTH public keys do not compress");
    },
    mnemonicToPrivateKey: (mnemonic, account = 0) => {
        const coinType = exports.SWTHAddress.coinType();
        const path = new BIP44Path(BIP44_PURPOSE, coinType).update(account).generate();
        const seed = BIP39.mnemonicToSeedSync(mnemonic);
        const masterKey = BIP32.fromSeed(seed);
        const hardenedDerivation = masterKey.derivePath(path);
        const privateKey = hardenedDerivation.privateKey;
        if (!privateKey)
            throw new Error("Private key derivation from mnemonic failed");
        return privateKey;
    },
    privateToPublicKey: (privateKey) => {
        const privateKeyBuff = exports.stringOrBufferToBuffer(privateKey);
        const publicKeyUint8Array = secp256k1.publicKeyCreate(privateKeyBuff, true);
        const publicKey = Buffer.from(publicKeyUint8Array);
        return publicKey;
    },
    privateKeyToAddress: (privateKey, opts) => {
        const publicKey = exports.SWTHAddress.privateToPublicKey(privateKey);
        const address = exports.SWTHAddress.publicKeyToAddress(publicKey, opts);
        return address;
    },
    encode: (hash, opts) => {
        const hashBuff = exports.stringOrBufferToBuffer(hash, "hex");
        const words = bech32.toWords(hashBuff.slice(0, 20));
        const addressPrefix = exports.SWTHAddress.getBech32Prefix(opts === null || opts === void 0 ? void 0 : opts.network, opts === null || opts === void 0 ? void 0 : opts.bech32Prefix, opts === null || opts === void 0 ? void 0 : opts.type);
        const address = bech32.encode(addressPrefix, words);
        return address;
    },
    generateAddress: (mnemonic, account = 0, opts) => {
        const privateKey = exports.SWTHAddress.mnemonicToPrivateKey(mnemonic, account);
        const address = exports.SWTHAddress.privateKeyToAddress(privateKey, opts);
        return address;
    },
    getBech32Prefix(net = constant_1.Network.MainNet, mainPrefix = constant_1.NetworkConfigs[net].Bech32Prefix, type = "main") {
        const addrPrefix = exports.SWTHAddress.addrPrefix;
        switch (type) {
            case "main":
                // e.g. swth
                return mainPrefix;
            case "validator":
                // e.g. swthvaloper
                return mainPrefix + addrPrefix.validator + addrPrefix.operator;
            case "consensus":
                // e.g. swthvalconspub
                return mainPrefix + addrPrefix.validator + addrPrefix.consensus + addrPrefix.public;
            default:
                return mainPrefix;
        }
    },
    addrPrefix: {
        validator: "val",
        operator: "oper",
        consensus: "cons",
        public: "pub",
    },
    getAddressBytes: (bech32Address, net) => {
        const prefix = exports.SWTHAddress.getBech32Prefix(net, undefined, "main");
        const { prefix: b32Prefix, words } = bech32.decode(bech32Address);
        if (b32Prefix !== prefix) {
            throw new Error("Prefix doesn't match");
        }
        return new Uint8Array(bech32.fromWords(words));
    },
    getModuleAddress: (moduleKey, network = constant_1.Network.MainNet) => {
        const addressHash = crypto_js_1.default.SHA256(moduleKey).toString(crypto_js_1.default.enc.Hex);
        return exports.SWTHAddress.encode(addressHash, { network });
    },
};
exports.NEOAddress = {
    coinType: () => {
        return NEO_COIN_TYPE;
    },
    publicKeyToScriptHash: (publicKey) => {
        const encodedPublicKey = exports.NEOAddress.encodePublicKey(publicKey);
        const addressScript = Buffer.concat([
            Buffer.from([0x21]),
            encodedPublicKey,
            Buffer.from([0xac]), // OptCode.CHECKSIG
        ]);
        const sha256Hash = ethers_1.ethers.utils.sha256(addressScript);
        const ripemdHash = ethers_1.ethers.utils.ripemd160(sha256Hash);
        return generic_1.stripHexPrefix(ripemdHash);
    },
    publicKeyToAddress: (publicKey) => {
        const addressScript = exports.NEOAddress.publicKeyToScriptHash(publicKey);
        const address = Base58Check.encode(addressScript, "17");
        return address;
    },
    encodePublicKey: (unencodedPublicKey) => {
        const unencPubKeyBuf = exports.stringOrBufferToBuffer(unencodedPublicKey);
        if (unencPubKeyBuf.length <= 33) {
            // length indicates already encoded
            return unencPubKeyBuf;
        }
        const pointXHex = unencPubKeyBuf.slice(1, 33);
        const pointYEven = unencPubKeyBuf[unencPubKeyBuf.length - 1] % 2 === 0;
        const compressedPublicKey = Buffer.concat([Buffer.from([pointYEven ? 0x02 : 0x03]), pointXHex]);
        return compressedPublicKey;
    },
    encode: (addressScript, version = "17") => {
        return Base58Check.encode(addressScript, version);
    },
    mnemonicToPrivateKey: (mnemonic, account = 0) => {
        const coinType = exports.NEOAddress.coinType();
        const path = new BIP44Path(BIP44_PURPOSE, coinType).update(account).generate();
        const seed = BIP39.mnemonicToSeedSync(mnemonic);
        const masterKey = BIP32.fromSeed(seed);
        const hardenedDerivation = masterKey.derivePath(path);
        const privateKey = hardenedDerivation.privateKey;
        if (!privateKey)
            throw new Error("Private key derivation from mnemonic failed");
        return privateKey;
    },
    privateToPublicKey: (privateKey) => {
        const privateKeyBuff = exports.stringOrBufferToBuffer(privateKey);
        const publicKeyUint8Array = secp256r1.publicKeyCreate(privateKeyBuff, true);
        return Buffer.from(publicKeyUint8Array);
    },
    privateKeyToAddress: (privateKey) => {
        const compressedPublicKey = exports.NEOAddress.privateToPublicKey(privateKey);
        const address = exports.NEOAddress.publicKeyToAddress(compressedPublicKey);
        return address;
    },
    generateAddress: (mnemonic, account = 0) => {
        const privateKey = exports.NEOAddress.mnemonicToPrivateKey(mnemonic, account);
        return exports.NEOAddress.privateKeyToAddress(privateKey);
    },
    isAddress: (address) => {
        return neon_core_next_1.wallet.isAddress(address, 0x17);
    },
};
exports.N3Address = Object.assign(Object.assign({}, exports.NEOAddress), { publicKeyToScriptHash: (publicKey) => {
        const publicKeyHex = exports.stringOrBufferToBuffer(publicKey).toString("hex");
        return neon_core_next_1.wallet.getScriptHashFromPublicKey(publicKeyHex);
    }, publicKeyToAddress: (publicKey) => {
        const addressScript = exports.N3Address.publicKeyToScriptHash(publicKey);
        return neon_core_next_1.wallet.getAddressFromScriptHash(addressScript);
    }, privateKeyToAddress: (privateKey) => {
        const compressedPublicKey = exports.N3Address.privateToPublicKey(privateKey);
        const address = exports.N3Address.publicKeyToAddress(compressedPublicKey);
        return address;
    }, generateAddress: (mnemonic, account = 0) => {
        const privateKey = exports.N3Address.mnemonicToPrivateKey(mnemonic, account);
        return exports.N3Address.privateKeyToAddress(privateKey);
    }, isAddress: (address) => {
        return neon_core_next_1.wallet.isAddress(address, neon_core_next_1.CONST.DEFAULT_ADDRESS_VERSION);
    }, encode: (addressScript, version = "35") => {
        return Base58Check.encode(addressScript, version);
    } });
exports.ETHAddress = {
    coinType: () => {
        return ETH_COIN_TYPE;
    },
    publicKeyToScriptHash: (publicKey) => {
        const encodedPublicKey = exports.ETHAddress.encodePublicKey(publicKey);
        return ethers_1.ethers.utils.keccak256(encodedPublicKey);
    },
    publicKeyToAddress: (publicKey) => {
        const publicKeyBuff = exports.stringOrBufferToBuffer(publicKey);
        return ethers_1.ethers.utils.computeAddress(publicKeyBuff);
    },
    publicKeyToBech32Address: (publicKey, opts) => {
        const hexAddress = exports.ETHAddress.publicKeyToAddress(publicKey);
        return exports.ETHAddress.encode(hexAddress.split('0x')[1], opts);
    },
    encodePublicKey: (unencodedPublicKey) => {
        const unencodedPublicKeyBuff = exports.stringOrBufferToBuffer(unencodedPublicKey);
        const publicKey = ethers_1.ethers.utils.computePublicKey(unencodedPublicKeyBuff, true);
        return Buffer.from(publicKey, "hex");
    },
    mnemonicToPrivateKey: (mnemonic, account = 0) => {
        var _a;
        const coinType = exports.ETHAddress.coinType();
        const path = new BIP44Path(BIP44_PURPOSE, coinType).update(account).generate();
        const wallet = ethers_1.ethers.Wallet.fromMnemonic(mnemonic, path);
        return Buffer.from((_a = wallet.privateKey) === null || _a === void 0 ? void 0 : _a.replace(/^0x/, ""), "hex");
    },
    privateToPublicKey: (privateKey) => {
        const privateKeyBuff = exports.stringOrBufferToBuffer(privateKey);
        return Buffer.from(ethers_1.ethers.utils.computePublicKey(privateKeyBuff).replace(/^0x/, ""), "hex");
    },
    privateKeyToAddress: (privateKey) => {
        const compressedPublicKey = exports.ETHAddress.privateToPublicKey(privateKey);
        const address = exports.ETHAddress.publicKeyToAddress(compressedPublicKey);
        return address;
    },
    generateAddress: (mnemonic, account = 0) => {
        const privateKey = exports.ETHAddress.mnemonicToPrivateKey(mnemonic, account);
        return exports.ETHAddress.privateKeyToAddress(privateKey);
    },
    encode: (hash, opts) => {
        const hashBuff = exports.stringOrBufferToBuffer(hash, "hex");
        const words = bech32.toWords(hashBuff.slice(0, 20));
        const addressPrefix = exports.SWTHAddress.getBech32Prefix(opts === null || opts === void 0 ? void 0 : opts.network, opts === null || opts === void 0 ? void 0 : opts.bech32Prefix, opts === null || opts === void 0 ? void 0 : opts.type);
        const address = bech32.encode(addressPrefix, words);
        return address;
    },
};
